// extracted by mini-css-extract-plugin
export default {"LinkWithArrow":"LinkWithArrow_LinkWithArrow__bNwDs","label":"LinkWithArrow_label__SoH8R","arrow":"LinkWithArrow_arrow__If7V0"};